export const overlayLogoOnImage = (base64Image, base64Logo) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      resolve(base64Image); // Fallback
      return;
    }

    const mainImg = new Image();
    mainImg.crossOrigin = "anonymous";

    mainImg.onload = () => {
      canvas.width = mainImg.width;
      canvas.height = mainImg.height;
      ctx.drawImage(mainImg, 0, 0);

      const logoImg = new Image();
      logoImg.onload = () => {
        // Logic for sizing
        const maxLogoWidth = canvas.width * 0.25; // 25% max width
        const maxLogoHeight = canvas.height * 0.2; // 20% max height
        
        let drawWidth = logoImg.width;
        let drawHeight = logoImg.height;

        // Scale down if too big to fit constraints
        const scaleX = maxLogoWidth / drawWidth;
        const scaleY = maxLogoHeight / drawHeight;
        const scale = Math.min(scaleX, scaleY); 

        if (scale < 1) {
          drawWidth *= scale;
          drawHeight *= scale;
        }

        const padding = canvas.width * 0.05;
        const x = canvas.width - drawWidth - padding;
        const y = canvas.height - drawHeight - padding;

        // Add a subtle shadow for better visibility on varying backgrounds
        ctx.shadowColor = "rgba(0,0,0,0.5)";
        ctx.shadowBlur = 10;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 4;

        ctx.drawImage(logoImg, x, y, drawWidth, drawHeight);
        resolve(canvas.toDataURL('image/png'));
      };
      logoImg.onerror = () => resolve(base64Image); // Return original if logo fails
      logoImg.src = base64Logo;
    };
    
    mainImg.onerror = (e) => reject(e);
    mainImg.src = base64Image;
  });
};
